module.exports = __webpack_public_path__ + "resources/13386f2b64779e1c52f6626d5bb1015f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/card-help.png
// module id = 236
// module chunks = 0